var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    d: "M19.9998 8.77197C13.6839 8.77197 8.77148 13.6843 8.77148 20.0002C8.77148 26.1406 13.6839 31.2284 19.9998 31.2284C26.1402 31.2284 31.228 26.1406 31.228 20.0002C31.228 13.6843 26.1402 8.77197 19.9998 8.77197Z",
    fill: "url(#paint0_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_2",
    d: "M19.9996 6.14044C20.7014 6.14044 21.2276 5.61411 21.2276 4.91234V1.22808C21.2276 0.526318 20.7014 0 19.9996 0C19.2978 0 18.7715 0.526318 18.7715 1.22808V4.91234C18.7715 5.61411 19.2978 6.14044 19.9996 6.14044Z",
    fill: "url(#paint1_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_3",
    d: "M19.9996 33.6848C19.2978 33.6848 18.7715 34.2111 18.7715 34.9129V38.7726C18.7715 39.2989 19.2978 40.0007 19.9996 40.0007C20.7014 40.0007 21.2276 39.2989 21.2276 38.7726V34.9129C21.2276 34.2111 20.7014 33.6848 19.9996 33.6848Z",
    fill: "url(#paint2_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_4",
    d: "M38.5969 18.7729H34.9127C34.2109 18.7729 33.6846 19.2993 33.6846 20.001C33.6846 20.7028 34.2109 21.2291 34.9127 21.2291H38.5969C39.2987 21.2291 40.0005 20.7028 40.0005 20.001C40.0005 19.2993 39.2987 18.7729 38.5969 18.7729Z",
    fill: "url(#paint3_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_5",
    d: "M6.14044 20.001C6.14044 19.2993 5.61415 18.7729 4.91238 18.7729H1.22811C0.526345 18.7729 0 19.2993 0 20.001C0 20.7028 0.526345 21.2291 1.22811 21.2291H4.91238C5.61415 21.2291 6.14044 20.7028 6.14044 20.001Z",
    fill: "url(#paint4_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_6",
    d: "M30.5288 10.5277C30.8797 10.5277 31.1721 10.4107 31.406 10.1768L34.0376 7.54515C34.5639 7.19427 34.5639 6.31706 34.0376 5.79074C33.5113 5.26442 32.8095 5.26442 32.2832 5.79074L29.6516 8.42236C28.9498 9.29956 29.4761 10.5277 30.5288 10.5277Z",
    fill: "url(#paint5_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_7",
    d: "M8.4199 29.6489L5.78828 32.2805C5.08652 33.1577 5.61284 34.3858 6.66549 34.3858C7.01637 34.3858 7.30877 34.2688 7.5427 34.0349L10.1743 31.4033C10.7006 30.877 10.7006 30.1752 10.1743 29.6489C9.82343 29.1226 8.94623 29.1226 8.4199 29.6489Z",
    fill: "url(#paint6_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_8",
    d: "M31.405 29.6489C30.8787 29.1226 30.1769 29.1226 29.6506 29.6489C29.1243 30.1752 29.1243 30.877 29.6506 31.4033L32.2822 34.0349C32.5161 34.2688 32.8085 34.3858 33.1594 34.3858C34.2121 34.3858 34.9138 33.1577 34.0366 32.2805L31.405 29.6489Z",
    fill: "url(#paint7_linear_312_3461)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>_9",
    d: "M8.41894 10.1768C8.65286 10.4107 8.94526 10.5277 9.29614 10.5277C10.5242 10.5277 11.0506 9.29956 10.1733 8.42236L7.54173 5.79074C7.01541 5.26442 6.31364 5.26442 5.78732 5.79074C5.261 6.31706 5.261 7.19427 5.78732 7.54515L8.41894 10.1768Z",
    fill: "url(#paint8_linear_312_3461)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_3461",
    x1: 16.5348,
    y1: -14.0634,
    x2: 44.9488,
    y2: 30.1357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_3461",
    x1: 21.9206,
    y1: -9.10013,
    x2: 45.9618,
    y2: 28.2948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_3461",
    x1: 3.99239,
    y1: -3.2543,
    x2: 28.0231,
    y2: 34.1247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_3461",
    x1: 17.3352,
    y1: -12.3503,
    x2: 42.2177,
    y2: 26.3557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_3461",
    x1: -4.45796,
    y1: 6.20258,
    x2: 20.4352,
    y2: 44.9261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_3461",
    x1: 13.2969,
    y1: -27.4273,
    x2: 57.7053,
    y2: 41.6523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_3461",
    x1: -18.9121,
    y1: -16.5956,
    x2: 25.4933,
    y2: 52.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_312_3461",
    x1: 10.81,
    y1: -7.45687,
    x2: 34.5506,
    y2: 29.4764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_312_3461",
    x1: 7.53647,
    y1: 0.702939,
    x2: 31.281,
    y2: 37.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6DB00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.6d3777c3222df64eaa6f8dca8787dd3e.svg";
export { ForwardRef as ReactComponent };